import React from 'react';

function Pricing() {
  const plans = [
    {
      name: 'Starter',
      price: '249',
      period: '/month',
      description: 'Perfect for small businesses just getting started',
      features: [
        'Single Store Location',
        'Up to 3 Users',
        'POS System',
        'Basic Inventory Management',
        'Supplier Tracking',
        'Sales Reports',
        'VAT Compliance',
        'Email Support'
      ],
      featured: false
    },
    {
      name: 'Professional',
      price: '350',
      period: '/month',
      description: 'Most popular for growing businesses',
      features: [
        'Up to 10 Users',
        'Advanced POS System',
        'Complete Inventory Management',
        'Advanced Analytics & Charts',
        'Thermal Printing Integration',
        'ZATCA QR Codes',
        'Priority Support',
        'Free Financial Reports',
      ],
      featured: true
    },
    {
      name: 'Enterprise',
      price: '500',
      period: '/month',
      description: 'For large businesses with multiple locations',
      features: [
        'Unlimited Store Locations',
        'Unlimited Users',
        'All Professional Features',
        'Custom Integrations',
        'Dedicated Account Manager',
        '24/7 Premium Support',
        'Staff Training Sessions',
        'Custom Branding Options'
      ],
      featured: false
    }
  ];

  return (
    <div className="pricing">
      <div className="pricing-container">
        <h1 className="section-title">Simple, Transparent Pricing</h1>
        <p className="section-subtitle">
          Choose the perfect plan for your business.
        </p>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
              {plan.featured && <div className="pricing-badge">Most Popular</div>}
              
              <h3>{plan.name}</h3>
              <div className="pricing-price">
                {plan.price} SAR
                <span>{plan.period}</span>
              </div>
              <p className="pricing-description">{plan.description}</p>

              <ul className="pricing-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>

              <button className="btn btn-primary">
                Start Free Trial
              </button>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '4rem', textAlign: 'center', padding: '2rem', background: '#e0f7f4', borderRadius: '12px' }}>
          <h3 style={{ color: '#1a3d4d', marginBottom: '1rem' }}>All Plans Include:</h3>
          <p style={{ color: '#718096', maxWidth: '800px', margin: '0 auto' }}>
             &nbsp;&nbsp; ✓ No Setup Fees &nbsp;&nbsp; ✓ Cancel Anytime &nbsp;&nbsp; 
            ✓ Free Updates &nbsp;&nbsp; ✓ Data Security &nbsp;&nbsp; ✓ Training Resources
          </p>
        </div>

        <div style={{ marginTop: '3rem', textAlign: 'center' }}>
          <h3 style={{ color: '#1a3d4d', marginBottom: '1rem' }}>Need a Custom Plan?</h3>
          <p style={{ color: '#718096', marginBottom: '1.5rem' }}>
            Contact us for enterprise solutions tailored to your specific business needs.
          </p>
          <a href="/contact" className="btn btn-primary">Contact Sales</a>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
